export default function CambiaPasswordPage() {
    return <h1>Cambia Password</h1>
}